import React from 'react';
import './Legal.css';
const Confidentialitate = () => {
  return (
    <>


      <div className="legal-container">
        <div className="legal-content">
          <div className="legal-section">
            <p><strong>Ultima actualizare:</strong> 28 noiembrie 2024</p>

            <h3>1. Cine suntem</h3>
            <p>SC CLADIDAV SRL oferă lecții de schi și snowboard prin Școala de Schi Fulg de Nea, în Cavnic, România.</p>
            <p>Contact: m_adi_i@yahoo.com</p>

            <h3>2. Ce date personale colectăm</h3>
            <p>Prin formularul de rezervare colectăm:</p>
            <ul>
              <li>Nume și prenume</li>
              <li>Adresă email</li>
              <li>Număr de telefon</li>
              <li>Vârsta participanților</li>
              <li>Nivel de experiență</li>
              <li>Preferințe pentru lecții</li>
            </ul>

            <h3>3. De ce colectăm aceste date</h3>
            <ul>
              <li>Pentru a procesa rezervarea</li>
              <li>Pentru a vă contacta în legătură cu lecțiile</li>
              <li>Pentru a trimite confirmări prin email</li>
            </ul>

            <h3>4. Cum folosim datele</h3>
            <ul>
              <li>Datele sunt trimise prin email către SC CLADIDAV SRL</li>
              <li>NU sunt stocate în baze de date permanente</li>
              <li>Sunt folosite DOAR pentru gestionarea rezervării</li>
            </ul>

            <h3>5. Cu cine le partajăm</h3>
            <p>Datele pot fi procesate de:</p>
            <ul>
              <li>Furnizorul de email (pentru trimiterea confirmărilor)</li>
              <li>Netopia Mobilpay (dacă alegeți plata cu cardul)</li>
            </ul>

            <h3>6. Drepturile dumneavoastră (GDPR)</h3>
            <p>Aveți dreptul să:</p>
            <ul>
              <li>Accesați datele personale</li>
              <li>Rectificați informații incorecte</li>
              <li>Ștergeți datele</li>
              <li>Limitați procesarea</li>
            </ul>
            <p>Pentru exercitarea drepturilor, contactați: m_adi_i@yahoo.com</p>

            <h3>7. Securitate</h3>
            <p>Folosim conexiuni securizate HTTPS pentru protejarea datelor.</p>

            <h3>8. Contact</h3>
            <p>Pentru întrebări: m_adi_i@yahoo.com</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Confidentialitate;